import { LightbulbNightIcon } from './LightbulbNightIcon';

/**
 * author: Michael Irigoyen
 * id E544DBA9-FBF4-4563-82BB-2D6F37788E2F
 * name lightbulb-night
 * version: 6.7.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/lightbulb-night.svg
 * tags
 * - Home Automation 
 */
export const LightbulbMoonStarIcon = LightbulbNightIcon;
export default LightbulbMoonStarIcon